import {Dexie} from 'dexie'

const dbName = 'quickome'
const dbVersion = 1

export class QuickOmeDb {
    db = null

    async initDb(initialData, deleteOldDb = false) {
        this.db = new Dexie(dbName)

        // check db version
        await new Dexie(dbName).open().then(async (db) => {
            // console.debug('initialize - current version X', db.verno)
            // console.debug('initialize - newest version X', dbVersion)
            deleteOldDb = deleteOldDb === true || db.verno < dbVersion
        }).catch(e => console.error (e))

        // console.debug('deleteOldDb', deleteOldDb)

        if (deleteOldDb) {
            await Dexie.delete(dbName)
            this.db = new Dexie(dbName)
        }

        this.db.version(dbVersion).stores({
            quickdata: '++id'
        })

        // check how many entries we have
        let count = await this.db.quickdata.count()

        // if no entries -> create first one
        if (count === 0) {
            // console.debug('dexieome - add initial entry')
            await this.db.quickdata.add(initialData)
        } else {
            // delete all other entries, we only need entry with id = 1
            await this.db.quickdata.where('id').above(1).delete()
        }
    }

    async getQuickData() {
        return await this.db.quickdata.where({'id': 1}).first()
    }

    async updateData(updateData) {
        // console.debug('updatedData', updateData)
        await this.db.quickdata.update({'id': 1}, updateData)
            .catch(e => console.error(e))
    }

    async delete() {
        await this.db.delete()
    }
}
